(function( $ ) {

	$.fn.loading = function( loading_img ) {
		if ( typeof loading_img === 'undefined' && typeof ScriptData.ajax_loader_url !== 'undefined' ) {
			loading_img = ScriptData.ajax_loader_url;
		}

		this.fadeTo( '400', '0.5' ).block( {
			message: null, overlayCSS: {
				background: 'transparent url(' + loading_img + ') no-repeat center',
				backgroundSize: '16px 16px',
				opacity: 0.5
			}
		} );

		return this;
	};

	$.fn.loaded = function() {
		this.stop( true ).css( 'opacity', '1' ).unblock();

		return this;
	};

})( jQuery );